// The following line loads the standalone build of Vue instead of the runtime-only build,
// so you don't have to do: import Vue from 'vue/dist/vue'
// This is done with the browser options. For the config, see package.json
import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
Raven.config('https://4e07d0d068054e6aae21cba4016796a5@sentry.io/142150')
     .addPlugin(RavenVue, Vue)
     .install()

// WMH - since this is the entry point and it is a .js file not a .vue file,
// it does NOT get the vueify transforms applied to it. Therefore do as little
// as conceivable here.
var App = require('./app.vue')
App.el = '#app'
const app = new Vue(App) // eslint-disable-line no-new
window.app = app
